import axios from "../clients/uspsServer";

export function fetchUspsSchemaDataApi() {
  return axios.get("/data/schema");
}
